
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('circle',{attrs:{"id":"a","cx":"16","cy":"16","r":"16"}})]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('mask',{attrs:{"id":"b","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#a"}})]),_c('use',{attrs:{"fill":"#F5F6F7","xlink:href":"#a"}}),_c('path',{attrs:{"d":"M16.5 32.333V17.167H25c1.105 0 2 .902 2 2.005V30l-10.5 2.333zM24.667 19.5h-5.834v1.167h5.834V19.5zm0 3.5h-5.834v1.167h5.834V23zm-9.684-7.438H8.567v1.313h6.416V19.5H8.567v1.313h6.416v2.625H8.567v1.312h6.416v7.583L6 30V10.995C6 9.893 6.902 9 8.005 9h8.823c1.108 0 2.005.899 2.005 2.005v4.557h-3.85zm1.517-4.229H8.333V12.5H16.5v-1.167z","fill":"#C8C9CA","mask":"url(#b)"}})])])
          )
        }
      }
    